export default (state, groupName) => {
  const groups = state.fullListOfCountryGroups;

  return groups.find((n) => n.sh_nm == groupName).uid;
};
